// test784
(784 && 0);
